import Welcome from '@/view/welcome/Welcome'
import MainMenu from '@/components/foundation/main-menu/MainMenu'

export default {
  path: '/welcome',
  name: 'Welcome',
  components: {
    default: Welcome,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'welcome',
    area: 'welcome',
    breadcrumb: [
      { name: 'Bem Vindo' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/welcome/index.js